import React from 'react'
import { Row, Col, Radio, Button } from 'antd'

import lang from '../../../../../../languages/en'
import styles from './styles.css'

const RadioGroup = Radio.Group

const SELECT_KEYS = {
    ADD_NEW_ONLY: 1,
    ADD_UPDATE_ALL: 2,
    REPLACE_ALL: 3,
}

const ITEM_NAME_SELECT_VALUES = [
    {
        key: SELECT_KEYS.ADD_NEW_ONLY,
        value: lang.item_name_import_add_new_only
    },
    {
        key: SELECT_KEYS.ADD_UPDATE_ALL,
        value: lang.item_name_import_add_update_all
    },
    {
        key: SELECT_KEYS.REPLACE_ALL,
        value: lang.item_name_import_replace_all
    }
]


class Step2 extends React.Component {
    state = {
        itemNameSettingCurrent: ITEM_NAME_SELECT_VALUES[0].key
    }

    onSelectUpdateSetting = e => {
        const value = e.target.value

        this.setState({
            itemNameSettingCurrent: value,
        })
        this.props.selectImportOption(value)
    }

    handleImport = () => {
        this.props.changeActionStep(3)
    }

    render() {
        const { fileUpload } = this.props

        return (
            <div id="step-2">
                <div id="import-item-name-settings-select">
                    <div className="header">
                        <Col span={3} offset={1} className="text-center import">{lang.item_name_import_file_title}</Col>
                        <Col span={20} className="text-center file-name">
                        {fileUpload && fileUpload.name}</Col>
                    </div>
                    <Row>
                        <Col span={4} />
                        <Col span={20} className="settings-select-content">
                            <div id="settings-select-desc">
                                <span>{lang.item_name_select_import_option}</span>
                            </div>
                            <RadioGroup
                                className="radio-group"
                                onChange={this.onSelectUpdateSetting}
                                value={this.state.itemNameSettingCurrent}
                            >
                                {
                                    ITEM_NAME_SELECT_VALUES.map(item => (
                                        <Radio
                                            key={item.key}
                                            className="radio-btn"
                                            value={item.key}
                                        >
                                            {item.value}
                                        </Radio>
                                    ))
                                }
                            </RadioGroup>
                        </Col>
                    </Row>
                    <Row className="footer-component">
                        <div className="fix-footer">
                            <Button
                                className="import ant-btn-primary"
                                onClick={this.handleImport}
                            >
                                Import
                            </Button>
                        </div>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Step2



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/import-panel/step2/index.js